import { useProfileStore } from '@entities/viewer'

interface KidPrivilegesReturn {
  canViewKids: ComputedRef<boolean>
  canManageKids: ComputedRef<boolean>
  canDeleteKids: ComputedRef<boolean>
  canViewCustomers: ComputedRef<boolean>
}

export const useKidPrivileges = (): KidPrivilegesReturn => {
  const profileStore = useProfileStore()

  const hasPrivilege = (key: string): ComputedRef<boolean> =>
    computed<boolean>(() => profileStore.privileges?.includes(key) ?? false)

  return {
    canViewKids: hasPrivilege('view-kids'),
    canManageKids: hasPrivilege('manage-kids'),
    canDeleteKids: hasPrivilege('delete-kids'),
    canViewCustomers: hasPrivilege('view-customers'),
  }
}
